import buildCorrectGrammarText from "Common/componentUtils/buildCorrectGrammarText";
export default {
    RUN_SCRIPT: "Запустить скрипт",
    getConfirmRunText: (count) => `Вы уверены, что хотите запустить\r\n${count} ${buildCorrectGrammarText(count, [
        "задачу",
        "задачи",
        "задач"
    ])}?`
};
